import { inject, injectable } from 'tsyringe';
import { ExtensionContext } from "../common/models/extension-config";
import { Module } from "../common/module";
import { ElementsIntegrationModule } from './elements-integration.module';

@injectable()
export class CommonModule extends Module {
    public name: string = 'CommonModule';

    constructor(@inject(ElementsIntegrationModule) private elementsIntegration: ElementsIntegrationModule) {
        super([elementsIntegration]);
    }
    public acceptedLicenseFlags: string[] = [];
    public shouldRun(context: ExtensionContext): boolean { return true; }
    public async run(): Promise<void> {
       
    }

    public wait(ms: number): Promise<void> {
        return new Promise<void>(r => setTimeout(() => r(), ms));
    }

    /**
     * Waits for a DOM element to appear in the specified inElement for maxSeconds.
     * @param selector The selector to look for
     * @param maxSeconds The maximum number of seconds to wait
     * @param inElement Use this element to search in
     * @returns The Element if successful, null if the element was not found in the specified number of seconds
     */
    public async waitForElement(selector: string, maxSeconds: number, inElement: Element): Promise<Element | null> {
        let elapsed = 0;
        while (elapsed <= maxSeconds * 1000) {
            const ret = inElement.querySelector(selector);
            if (ret) {
                return ret;
            }
            await this.wait(500);
            elapsed += 500;
        }
        return null;
    }

    /**
     * Gets the Dashboard document. If we are in VizPortal, it returns the Dashboard vizql iframe document. If we are in VizQL, it returns the current document
     * @returns The HTMLDocument that contains the visualization
     */
    public async getDashboardDocument(waitSeconds: number = 60): Promise<Document | null> {
        const dashboardIframeSelector = `iframe[src^="${window.location.origin}"]`;
        switch (this.elementsIntegration.config.context) {
            case ExtensionContext.vizql:
                return document;
            case ExtensionContext.vizportal:
                const iframe = await this.waitForElement(dashboardIframeSelector, waitSeconds, document.body);
                if (iframe === null) {
                    return null;
                }
                return (<HTMLIFrameElement>iframe).contentDocument;
        }
    }

    public getTableauApiVersion(): { major: number, minor: number} {
        const r = /^(\d+)\.(\d+)$/.exec(this.elementsIntegration.config.serverVersion);
        if (!r || !r[1] || !r[2]) {
            throw new Error('Failed to parse tableau version');
        }
        return {
            major: +r[1],
            minor: +r[2]
        };
    }

}